import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { SabSkeleton } from "web_myplann/Shared/Skeletons";

const ROWS = [0, 1, 2, 3, 4, 5];

export const ChatListSkeleton: FC = () => {
	const theme = useTheme();

	return (
		<Stack bgcolor={theme.palette.background.paper}>
			{ROWS.map((row) => (
				<Stack
					key={row}
					direction="row"
					alignItems="center"
					gap={1.2}
					px={1.6}
					py={1.2}
					borderBottom={1}
					borderColor="surface.border"
				>
					<SabSkeleton variant="circular" width={48} height={48} />
					<Stack flex={1} gap={0.6}>
						<SabSkeleton variant="text" width="55%" height={16} />
						<SabSkeleton variant="text" width="85%" height={14} />
					</Stack>
				</Stack>
			))}
		</Stack>
	);
};
